type PrimeLoopIconProps = {
  className?: string;
};

export const PrimeLoopIcon = ({ className }: PrimeLoopIconProps) => (
  <svg
    width='23'
    height='23'
    viewBox='0 0 23 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden
  >
    <path
      d='M11.1859 22.4523C17.3639 22.4523 22.3719 17.4259 22.3719 11.2262C22.3719 5.02642 17.3639 0 11.1859 0C5.00793 0 0 5.02642 0 11.2262C0 17.4259 5.00793 22.4523 11.1859 22.4523Z'
      fill='var(--logo-prime-bg)'
    />
    <g clipPath='url(#prime_loop_icon_clip)'>
      <path
        d='M7.75 9.65781C7.76922 9.50425 7.86519 9.36025 7.99957 9.28349L10.956 7.57489C11.0328 7.5269 11.1191 7.50772 11.2055 7.50772V5.18481C10.908 5.18481 10.6104 5.10802 10.3512 4.95444L7.75 3.45703V9.65781Z'
        fill='url(#prime_loop_icon_g0)'
      />
      <path
        d='M11.1992 5.18481V7.50772C11.2952 7.50772 11.3816 7.5269 11.468 7.57489L14.4244 9.28349C14.5396 9.35066 14.6163 9.45626 14.6547 9.57143V3.45703L12.0535 4.95444C11.7847 5.10802 11.4968 5.18481 11.1992 5.18481Z'
        fill='var(--logo-prime-mid)'
      />
      <path
        d='M4.27344 17.4328L7.74815 19.4293V3.45703L4.27344 5.45357V17.4232V17.4328Z'
        fill='var(--logo-prime-mid)'
      />
      <path
        d='M18.131 5.45356L14.6562 3.45703V19.4293L18.131 17.4328V5.46316V5.45356Z'
        fill='url(#prime_loop_icon_g1)'
      />
      <path
        d='M11.2055 15.3806C11.1191 15.3806 11.0328 15.3518 10.956 15.3134L7.99957 13.6048C7.86519 13.528 7.76922 13.3841 7.75 13.2305V19.4313L10.3512 17.9339C10.62 17.7803 10.908 17.7035 11.2055 17.7035V15.3806Z'
        fill='url(#prime_loop_icon_g2)'
      />
      <path
        d='M12.0535 17.9334L14.6547 19.4308V13.3164C14.6163 13.4316 14.5396 13.5372 14.4244 13.6044L11.468 15.313C11.3816 15.361 11.2952 15.3801 11.1992 15.3801V17.703C11.4968 17.703 11.7943 17.7798 12.0535 17.9334Z'
        fill='var(--logo-prime-mid)'
      />
    </g>
    <defs>
      <linearGradient
        id='prime_loop_icon_g0'
        x1='7.75'
        y1='6.55743'
        x2='11.2055'
        y2='6.55743'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='var(--logo-prime-gradient-start)' />
        <stop offset='1' stopColor='var(--logo-prime-gradient-end)' />
      </linearGradient>
      <linearGradient
        id='prime_loop_icon_g1'
        x1='14.6562'
        y1='11.4432'
        x2='18.131'
        y2='11.4432'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='var(--logo-prime-gradient-start)' />
        <stop offset='1' stopColor='var(--logo-prime-gradient-end)' />
      </linearGradient>
      <linearGradient
        id='prime_loop_icon_g2'
        x1='7.75'
        y1='16.3309'
        x2='11.2055'
        y2='16.3309'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='var(--logo-prime-gradient-start)' />
        <stop offset='1' stopColor='var(--logo-prime-gradient-end)' />
      </linearGradient>
      <clipPath id='prime_loop_icon_clip'>
        <rect width='13.9872' height='16.3184' fill='white' transform='translate(4.19531 3.37891)' />
      </clipPath>
    </defs>
  </svg>
);
